module.exports = __webpack_public_path__ + "img/backpack.1acce345.svg";